import ProgramAssistantTable from './Table';

export default ProgramAssistantTable;
